// src/components/HomePage.jsx
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { PageLoader } from './PageLoader';  // Changed to named import
import { createLogger } from '../utils/logger';

const logger = createLogger('Shell::HomePage');

const HomePage = () => {
    const navigate = useNavigate();
    const { loading, isSuperuser, hasAssignedCompany, primaryCompany } = useAuth();

    useEffect(() => {
        if (loading) return;

        if (isSuperuser || !hasAssignedCompany) {
            logger.info('Redirecting to company selection', { isSuperuser });
            navigate('/app/dashboard', { replace: true });
        } else {
            logger.info('Redirecting to company dashboard', {
                companyId: primaryCompany.id,
                companyName: primaryCompany.name
            });
            navigate(`/app/dashboard/company/${primaryCompany.id}`, { replace: true });
        }
    }, [loading, isSuperuser, hasAssignedCompany, primaryCompany, navigate]);

    return <PageLoader />;
};

export default HomePage;